<circ-loader [isLoading]="(providers$ | async) === null">
  <h2>{{ 'step_new_legend' | i18n }}</h2>
  <kendo-dropdownlist [data]="providers$ | async" textField="name" valueField="id" [(ngModel)]="selectedProvider">
  </kendo-dropdownlist>
  <div *ngIf="selectedProvider !== null">
    <ng-container *ngComponentOutlet="selectedProvider?.createTemplateComponent"></ng-container>
  </div>
</circ-loader>
